import { FantasyMatchupPosition } from '@pff-consumer/schema'
import { PlayerPosition } from '@pro-football-focus/pffkit-node-client'

export const convertToRbIfPositionIsHbOrFb = (position: PlayerPosition) => {
  if (position === PlayerPosition.HalfBack || position === PlayerPosition.FullBack) return FantasyMatchupPosition.RB
  return position
}
